
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v25/es/membership",
      function () {
        return require("private-next-pages/v25/es/membership/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v25/es/membership"])
      });
    }
  